var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { dbToGainValue } from '../audio-helper';
import BaseAudioEffector from './base-audio-effector';
/**
 * 音效增益效果
 */
var GainEffector = /** @class */ (function (_super) {
    __extends(GainEffector, _super);
    function GainEffector(audioCtx, audioSource, logger) {
        var _this = _super.call(this, audioCtx, audioSource, logger) || this;
        // 最大音量增益200%，对应值为10分贝
        _this.maxGainValue = 2;
        // 最小音量增益0%，即不做任何增益，对应值为0分贝
        _this.minGainValue = 0;
        _this.currentGainValue = _this.minGainValue;
        // 以指数方式接近目标值的速率常量，数值越大该过渡越慢
        _this.gainTimeConstant = 0.02;
        _this.effectorName = 'Gain';
        _this.gainNode = audioCtx.createGain();
        return _this;
    }
    GainEffector.prototype.connectBy = function (node) {
        if (!node) {
            return null;
        }
        node.connect(this.gainNode);
        return this.gainNode;
    };
    GainEffector.prototype.disconnect = function () {
        var _a;
        if (!this.gainNode) {
            return;
        }
        this.gainNode.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.effectorName, " disconnect()"));
    };
    GainEffector.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.gainNode = null;
    };
    /**
     * 获取增益百分比
     */
    GainEffector.prototype.getGainValue = function () {
        return this.currentGainValue;
    };
    /**
     * 设置增益百分比，范围[0,2]
     * 比如传入0.5，意味在当前音量大小下增益50%，最大增益到100%
     * @param value 增益值
     */
    GainEffector.prototype.setGainValue = function (value) {
        var _a;
        if (!this.gainNode) {
            return;
        }
        // 先检查范围，确保在min和maxGainValue范围内，如果小于minGainValue，就恢复无增益效果
        this.currentGainValue = Math.max(value, this.minGainValue);
        this.currentGainValue = Math.min(this.currentGainValue, this.maxGainValue);
        // 增益值到分贝转换计算
        var db = (this.currentGainValue - this.minGainValue) * 10;
        // 在给定时间以具有给定时间常数的速率开始以指数方式接近目标值
        this.gainNode.gain.setTargetAtTime(dbToGainValue(db), this.audioCtx.currentTime, this.gainTimeConstant);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("GainEffector setGainValue() value=".concat(value, ",db=").concat(db));
    };
    return GainEffector;
}(BaseAudioEffector));
export default GainEffector;
